import { PaletteOptions } from "@mui/material";

export default {
    mode: "light",
    primary: {
        main: "#3452C1",
        0: "#FFFFFF",
        3: "#DCE0E5",
        4: "#D9D9D9",
        5: "#BFBFBF",
        6: "#8C8C8C",
        7: "#595959",
        8: "#507AFE",
        50: "#F1F5FD",
        60: "#F6F7F9",
        100: "#DFEAFA",
        200: "#C7DAF6",
        300: "#A7C6F1",
        400: "#73A1E7",
        500: "#5281DF",
        600: "#3D64D3",
        700: "#3452C1",
        800: "#30449D",
        color: "rgba(255,255,255,0.10)",
        color1: "rgba(241,245,253,0.10)",
        color3: "rgba(255,255,255,0.20)",
        opacity: {
            white50: "#FFFFFF80",
            black3: "#00000008",
            black43: "#00000070",
        },
        navBarColors: {
            button_bg_clr: "rgba(255,255,255,0.25)",
            button_border_clr: "rgba(255,255,255)",
            button_selected_bg_clr: "rgba(241, 245, 253, 0.20)",
            profile_hover: "#4E7BA1",
            modal_color: "rgba(46,93,132, 0.8)",
            modal_border: "rgba(255,255,255,0.40)"
        },
        blue: {
            500: "#2196F3",
            600: "#3D64D3"
        },
        green: {
            500: "#428A7C",
            600: "#52C41A"
        },
        yellow: {
            900: "#F57F17",
            main: "#FAAD14",
        },
        neutral: {
            1: "#FAFAFA",
            4: "#D9D9D9",
            3: "#F0F0F0",
            5: "#BFBFBF",
            6: "#8C8C8C",
            7: "#595959",
            9: "#262626",
            10: "#1F1F1F",
            13: "#000"
        },
        volcano: {
            5: "#FF7A45",
        },
    },
    red: {
        900: "#B71C1C"
    },
    dustRed: {
        background: "#FFF1F0",
        primary: "#A8071A",
        secondary: "#5C0011",
        1: "#FFF1F0",
        3: "#FFA39E",
        4: "#FF7875",
        5: "#FF4D4F",
        6: "#F5222D",
        7: "#CF1322",
        8: "#A8071A",
        50: "#FEEBEE",
        900: "#B71C1C"
    },
    orange: {
        900: "#E65100"
    },
    sunsetOrange: {
        background: "#FFF7E6",
        primary: "#AD4E00",
        seconday: "#612500",
        1: "#FFF7E6",
        4: "#FFC069",
        6: "#FA8C16",
        7: "#D46B08",
        8: "#AD4E00"
    },
    sunriseYellow: {
        7: "#AD8B00"
    },
    polarGreen: {
        1: "#F6FFED",
        4: "#95DE64",
        6: "#52C41A",
        7: "#389E0D",
        8: "#237804",
        9: "#135200"
    },
    calendulaGold: {
        1: "#FFFBE6",
        10: "#613400"
    },
    neutral: {
        1: "#FAFAFA",
        5: "#BFBFBF",
        7: "#595959",
        10: "#1F1F1F"
    },
    secondary: {
        main: "#323232",
        100: "#D9EEE7",
        200: "#9BFCCD",
    },
    text: {
        primary: "rgba(0, 0, 0, 0.87)",
        0: "#000000",
        3: "#6F7C8E",
        5: "#BFBFBF",
        7: "#595959",
        8: "#434343",
        10: "#1F1F1F",
        100: "#262626",
        300: "#9e9e9e",
        400: "#73A1E7",
        500: "#5281DF",
        700: "#D32F2F",
        600: "#3D64D3",
        900: "#2B3C7D",
        950: "#1F274C",
        blackBlue: "#101828",
        veryDark: "#2C5953",
        ashyNeutralShade: "#9e9e9e",
        strongOrange: "#D46B08",
        approxSafetyOrange: "#FF6F00",
        cancelButton: "#344054",
        resetAll: "#3D64D3"
    },
    background: {
        paper: "#FFF",
        grey: "#FAFAFA",
        blue: "#E9EAEC",
        lightGrayishCyan: "#F4F9F8",
        whiteSmoke: "#F5F5F5",
        ghostWhite: "#F9F9F9",
        strongGreen: "#52C41A",
        veryPaleYellow: "#FFF8E1",
        neutral3: "#F0F0F0",
    },
    border: {
        lightGray: "#ddd",
        darkGrayishRed: "#adacac",
        lightGrayishRed: "#c0c0c0",
        lightGrey: "#E9EAEC",
        lightGreen: "#F4F9F8",
        borderGrey: "#DDDDDD",
        lightGrayD3: "#D3D3D3",
        veryLightGrayF5: "#F5F5F5",
        cyanBlue: "#A7C6F1",
        metallicGray: "#c0c0c0",
        lightGrayishBlue: "#E4E7EC",
        red300: "#E57373",
        cancelButton: "#D0D5DD"
    },
    shadow: {
        approxBlackRussian: "#101828",
    },
    device: {
        Assigned: {
            color: "#3452C1",
            bgColor: "#F1F5FD",
            borderColor: "#A7C6F1",
        },
        "Pending Retrieved - Hospitalization": {
            color: "#613400",
            bgColor: "#FFFBE6",
            borderColor: "#FFFE58F",
        },
        Lost: {
            color: "#D4380D",
            bgColor: "#FFF2E8",
            borderColor: "#FFBB96",
        },
        Faulty: {
            color: "#595959",
            bgColor: "#FAFAFA",
            borderColor: "#F0F0F0",
        },
        "Pending Retrieved - Unexpected Transfer": {
            color: "#2C5953",
            bgColor: "#F4F9F8",
        },
    },
    icons: {
        sunsetOrange: "#FA8C16",
        moderateBlue: "#3D64D3",
        darkGreen: "#389E0D",
        strongRed: "#CF1322",
        grey: "#667085"
    },
    recentProject: {
        New: {
            color: "#135200",
            bgColor: "#D9F7BE",
        },
        "On-going": {
            color: "#2B3C7D",
            bgColor: "#DFEAFA",
        },
        Closed: {
            color: "#262626",
            bgColor: "#F0F0F0",
        },
    },
    alertCard: {
        high: {
            color: "#CF1322",
            bgColor: "#FFF1F0",
            borderColor: "#FFA39E",
        },
        mid: {
            color: "#D46B08",
            bgColor: "#FFF7E6",
            borderColor: "#FFD591",
        },
        low: {
            color: "#000000",
            bgColor: "#FAFAFA",
            borderColor: "#595959",
        },
    },
    clinicianStatus: {
        online: "#52C41A",
        "on-break": "#FAAD14",
        offline: "#8C8C8C"
    },
    riskScoring: {
        "risk0": "#389E0D",
        "risk1": "#E65100",
        "risk2": "#B71C1C",
        "risk3": "#B71C1C",
    },
    diagnosisNote: {
        general: {
            color: "#3D64D3",
            bgcolor: "#F1F5Fd",
            borderColor: "#73A1E7"
        },
        consultation: {
            color: "#5CA596",
            bgcolor: "#F4F9F8",
            borderColor: "#5CA596"
        },
        draft: {
            color: "#1F1F1F",
            bgcolor: "#FFF",
            borderColor: "#D9D9D9"
        },
    }
} as PaletteOptions;
